module.exports = __webpack_public_path__ + "img/toll-blue-fill.3f565eab.svg";